var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 18.125V1.87501C1.25 1.52981 1.5298 1.25001 1.875 1.25001H11.25V3.75001C11.25 4.44036 11.8096 5.00001 12.5 5.00001H15V6.87501H16.25V4.37501C16.251 4.20888 16.1857 4.04919 16.0687 3.93126L12.3187 0.18126C12.2008 0.0642678 12.0411 -0.000927527 11.875 9.97262e-06H1.875C0.839453 9.97262e-06 0 0.839502 0 1.87501V18.125C0 19.1606 0.839453 20 1.875 20H6.25V18.75H1.875C1.52984 18.75 1.25 18.4702 1.25 18.125Z",
    fill: "#368B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19375 10.3437L7.5 11.725L6.80625 10.3437C6.70035 10.1336 6.48535 10.0007 6.25 10H5V11.25H5.8625L6.8 13.125L5.8625 15H5V16.25H6.25C6.48535 16.2493 6.70035 16.1164 6.80625 15.9063L7.5 14.525L8.19375 15.9063C8.29965 16.1164 8.51465 16.2493 8.75 16.25H10V15H9.1375L8.2 13.125L9.1375 11.25H10V10H8.75C8.51465 10.0007 8.29965 10.1336 8.19375 10.3437Z",
    fill: "#368B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.125 12.5H16.875C16.5298 12.5 16.25 12.2202 16.25 11.875C16.25 11.5298 16.5298 11.25 16.875 11.25H18.125C18.4702 11.25 18.75 11.5298 18.75 11.875H20C20 10.8395 19.1605 10 18.125 10H16.875C15.8395 10 15 10.8395 15 11.875C15 12.9105 15.8395 13.75 16.875 13.75H18.125C18.4702 13.75 18.75 14.0298 18.75 14.375C18.75 14.7202 18.4702 15 18.125 15H16.875C16.5298 15 16.25 14.7202 16.25 14.375H15C15 15.4105 15.8395 16.25 16.875 16.25H18.125C19.1605 16.25 20 15.4105 20 14.375C20 13.3395 19.1605 12.5 18.125 12.5Z",
    fill: "#368B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 10H10.625V15.625C10.625 15.9702 10.9048 16.25 11.25 16.25H14.375V15H11.875V10Z",
    fill: "#368B43"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.dd0c507cbc9b958cd6ef1663f6c9f9e8.svg";
export { ForwardRef as ReactComponent };